import script from "./DownloadAndUploadButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadAndUploadButtons.vue?vue&type=script&setup=true&lang=js"

import "./DownloadAndUploadButtons.vue?vue&type=style&index=0&id=55e5215a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e5215a"]])

export default __exports__